<div class="center-xy" [ngStyle]="{ overflow: zones.overflow ? 'auto' : 'hidden' }"
    *ngIf="zones.selectedZone">
    <div class="zone-control-wrapper bg-light" data-testid="zone-info-control">
        <div class="zone-control__top">
            <div class="zone-control__top-icon bg-style bg-style__icon border-light">
                <img ngSrc="/assets/img/zone_icons/light/{{zone.description['styleIcon']}}.svg"
                     width="45" height="45" alt="" />
            </div>
            <p class="zone-control__top-name font-bold font-24 bg-style bg-style__label color-light">
                {{ zones.getZoneName(zones.selectedZone) }}
            </p>
        </div>

        <div class="zone-control__content">
            <div class="zone-control__buttons-top">
                <div class="zone-control__close-button cursor-pointer bg-cancel bg-cancel__button"
                    data-testid="close-control"
                    (click)="zones.goBack()">
                    <img ngSrc="/assets/img/zone_icons/back_without_border.svg"
                        width="40" height="40" alt="" />
                </div>
            </div>

            <div class="dropdown-list dropdown-list--info">
                <div class="dropdown-list__item color-basic font-14 font-bold"
                     *ngIf="zones.selectedZone['zone'].flags.algorithm == 'cooling'">
                    <p class="dropdown-list__item-name">{{ subtitle(2459) }}</p>
                    <div class="dropdown-list__value dropdown-list__value--single">
                        <p class="dropdown-list__value-name">
                            {{ subtitle(1815) }}
                        </p>
                    </div>
                </div>

                @if (zone.mode.mode === 'timeLimit') {
                    <div class="dropdown-list__item color-basic font-14 font-bold">
                        <p class="dropdown-list__item-name">{{ subtitle(3516) }}</p>
                    </div>
                }

                @if ((zone.mode.mode === 'localSchedule'
                    || zone.mode.mode === 'globalSchedule')
                    && !views.zonesView.withoutGlobalSchedules) {
                    <div class="dropdown-list__item color-basic font-14 font-bold">
                        <p class="dropdown-list__item-name">{{ subtitle(293) }}</p>
                        <div class="dropdown-list__value dropdown-list__value--single">
                            <p class="dropdown-list__value-name">
                                @if (zone.mode.mode === 'localSchedule') {
                                    {{ subtitle(3587) }}
                                } @else {
                                    {{ zones.getScheduleName(zone.mode.scheduleIndex) }}
                                }
                            </p>
                        </div>
                    </div>
                }

                <div class="dropdown-list__item color-basic font-14 font-bold"
                    *ngIf="zones.selectedZone['zone'].signalStrength !== null
                        || zones.selectedZone['zone'].batteryLevel !== null">
                    <p class="dropdown-list__item-name"
                        [ngClass]="{ 'color-alarm': zone.zone.batteryLevel <= 10
                            && zone.zone.batteryLevel !== null }">
                        {{ subtitle(3589) }}
                    </p>
                    <div class="dropdown-list__value">
                        <div class="dropdown-list__value-wrapper">
                            <div class="dropdown-list__value dropdown-list__value--small"
                                *ngIf="zone.zone.batteryLevel !== null">
                                <img class="dropdown-list__battery"
                                    ngSrc="/assets/img/zone_icons/battery.svg"
                                    width="16" height="16" alt="" />
                                     <p class="dropdown-list__value-name"
                                        data-testid="battery-level"
                                        [ngClass]="{ 'color-alarm': zone.zone.batteryLevel <= 10 }">
                                         {{ zone.zone.batteryLevel | format:8 }}
                                     </p>
                            </div>
                        </div>
                        <div class="dropdown-list__value-wrapper">
                            <div class="dropdown-list__value dropdown-list__value--small"
                                *ngIf="zone.zone.signalStrength !== null">
                                       <img class="dropdown-list__signal"
                                           data-testid="signal-icon"
                                           ngSrc="{{ zones.signalIcon(zone.zone)}}"
                                           width="19" height="19" alt="" />
                            </div>
                        </div>
                    </div>
                </div>

                <div class="dropdown-list__item color-basic font-14 font-bold"
                    *ngIf="zones.selectedZone['zone'].humidity > 0">
                    <p class="dropdown-list__item-name">{{ subtitle(5465) }}</p>
                    <div class="dropdown-list__value dropdown-list__value--actuator">
                        <img class="dropdown-list__actuators-open"
                             ngSrc="/assets/img/zone_icons/humidity.svg"
                             width="16" height="16" alt="" />
                        <p class="dropdown-list__value-name">
                            {{ zone.zone.humidity | format:8 }}
                        </p>
                    </div>
                </div>

                <div class="dropdown-list__item color-basic font-14 font-bold"
                    *ngIf="zones.selectedZone['actuators'].length > 0">
                    <p class="dropdown-list__item-name">
                        {{ subtitle(1161) }}
                    </p>
                    <div class="dropdown-list__value dropdown-list__value--actuator">
                        <img class="dropdown-list__actuators-open"
                             ngSrc="/assets/img/zone_icons/actuators__open.svg"
                             width="16" height="16" alt="" />
                        <p class="dropdown-list__value-name">
                            {{ zone.zone.actuatorsOpen | format:8 }}
                        </p>
                    </div>
                </div>

                <div class="dropdown-list__item color-basic font-14 font-bold"
                    *ngIf="zones.selectedZone['zone'].flags.humidityAlgorytm  > 0">
                    <p class="dropdown-list__item-name">{{ subtitle(6372) }}</p>
                    <div class="dropdown-list__value dropdown-list__value--single">
                        <p class="dropdown-list__value-name">
                            {{ subtitle(3498) }}
                        </p>
                    </div>
                </div>

                <div class="dropdown-list__item color-basic font-14 font-bold"
                    *ngFor="let actuator of zones.selectedZone['actuators']">
                    <p class="dropdown-list__item-name"
                        [ngClass]="{ 'color-alarm': actuator.state !== 'noAlarm' }">
                        {{ subtitle(2729) + ' ' + (actuator.index) }}
                    </p>

                    <div *ngIf="actuator.state !== 'noAlarm'
                            && actuator.state !== 'waiting'"
                         class="dropdown-list__value dropdown-list__value--wide"
                         [ngClass]="{ 'color-alarm': actuator.state != 'noAlarm' }">
                        <div *ngIf="actuator.state != 'noAlarm'
                                && actuator.state !== 'waiting'"
                            class="dropdown-list__value dropdown-list__value--wide"
                            [ngClass]="{ 'color-alarm': actuator.state !== 'noAlarm' }">
                            <div>{{ subtitle(4282) }}</div>
                            <div class="dropdown-list__value--single">
                                {{ zones.getStateSubtitle(actuator.state) }}
                            </div>
                        </div>
                    </div>

                    <div class="dropdown-list__value dropdown-list__value--single"
                        *ngIf="actuator.state === 'waiting'">
                        <p class="dropdown-list__value-name">
                            {{ subtitle(3162) }}
                        </p>
                    </div>

                    <div class="dropdown-list__value"
                        *ngIf="actuator.state == 'noAlarm'">
                        <div class="dropdown-list__value-wrapper">
                            <div class="dropdown-list__value dropdown-list__value--small"
                                *ngIf="actuator.batteryLevel !== null">
                                <img class="dropdown-list__battery"
                                     ngSrc="/assets/img/zone_icons/battery.svg"
                                     width="16" height="16" alt="" />
                                       <p class="dropdown-list__value-name"
                                          data-testid="battery-level"
                                          [ngClass]="{ 'color-alarm': actuator.state !== 'noAlarm' }">
                                           {{ actuator.batteryLevel | format:8 }}
                                       </p>
                            </div>
                        </div>
                        <div class="dropdown-list__value-wrapper">
                            <div class="dropdown-list__value dropdown-list__value--small"
                                *ngIf="actuator.signalStrength !== null">
                                           <img class="dropdown-list__signal"
                                               data-testid="signal-icon"
                                               ngSrc="{{ zones.signalIcon(actuator) }}"
                                               width="16" height="16" alt="" />
                            </div>
                        </div>
                    </div>
                </div>

                <div *ngFor="let sensor of zones.selectedZone['windowsSensors']">
                    <div class="dropdown-list__item color-basic font-14 font-bold">
                        <p class="dropdown-list__item-name"
                            [ngClass]="{ 'color-alarm': sensor.state !== 'noAlarm' }">
                            {{ subtitle(3876) + ' ' + (sensor.index) }}
                        </p>
                        <div class="dropdown-list__value"
                            *ngIf="sensor.state == 'noAlarm'">
                            <div class="dropdown-list__value-wrapper">
                                <div class="dropdown-list__value dropdown-list__value--small"
                                    *ngIf="sensor.batteryLevel !== null">
                                    <img class="dropdown-list__battery"
                                        ngSrc="/assets/img/zone_icons/battery.svg"
                                        width="16" height="16" alt="" />
                                    <p class="dropdown-list__value-name"
                                        data-testid="battery-level"
                                        [ngClass]="{ 'color-alarm': sensor.state != 'noAlarm' }">
                                        {{ sensor.batteryLevel | format:8 }}
                                    </p>
                                </div>
                            </div>
                            <div class="dropdown-list__value-wrapper">
                                <div class="dropdown-list__value dropdown-list__value--small"
                                    *ngIf="sensor.signalStrength !== null">
                                                       <img class="dropdown-list__signal"
                                                           data-testid="signal-icon"
                                                           ngSrc="{{zones.signalIcon(sensor)}}"
                                                           width="16" height="16" alt="" />
                                </div>
                            </div>
                        </div>

                        <div class="dropdown-list__value dropdown-list__value--single"
                            *ngIf="sensor.state == 'waiting'">
                            <p class="dropdown-list__value-name">
                                {{ subtitle(3162) }}
                            </p>
                        </div>
                        <div class="dropdown-list__value dropdown-list__value--single"
                             *ngIf="sensor.state == 'noCommunication'"
                             [ngClass]="{ 'color-alarm': sensor.state != 'noAlarm' }">
                            <p class="dropdown-list__value-name">
                                {{ subtitle(1808) }}
                            </p>
                        </div>
                        <div class="dropdown-list__value dropdown-list__value--single"
                            *ngIf="sensor.state == 'lowBattery'"
                            [ngClass]="{ 'color-alarm': sensor.state != 'noAlarm' }">
                            <p class="dropdown-list__value-name">
                                {{ subtitle(2885) }}
                            </p>
                        </div>
                        <div class="dropdown-list__value dropdown-list__value--single"
                            *ngIf="sensor.state == 'unregistered'"
                            [ngClass]="{ 'color-alarm': sensor.state != 'noAlarm' }">
                            <p class="dropdown-list__value-name">
                                {{ subtitle(3674) }}
                            </p>
                        </div>
                    </div>
                    <div class="dropdown-list__item color-basic font-14 font-bold"
                        *ngIf="sensor.state == 'noAlarm'">
                        <p class="dropdown-list__item-name">
                            {{ subtitle(3956) }}
                        </p>
                        <div class="dropdown-list__value dropdown-list__value--single">
                            <p class="dropdown-list__value-name"
                                *ngIf="sensor.windowState == 'open'">
                                {{ subtitle(3912) }}
                            </p>
                            <p class="dropdown-list__value-name"
                                *ngIf="sensor.windowState == 'closed'">
                                {{ subtitle(3913) }}
                            </p>
                        </div>
                    </div>
                </div>

                <div class="dropdown-list__item color-basic font-14 font-bold"
                    *ngFor="let contact of zones.selectedZone['additionalContacts']">
                    <p *ngIf="contact.textNumber === 0 || contact.textNumber === null"
                        class="dropdown-list__item-name"
                        [ngClass]="{ 'color-alarm': contact.state !== 'noAlarm'
                            && contact.state !== 'waiting' }">
                        {{ subtitle(729) + ' ' + (contact.index) }}
                    </p>
                    <p *ngIf="contact.textNumber !== 0
                            && contact.textNumber !== null && contact.index === 1"
                       class="dropdown-list__item-name"
                       [ngClass]="{ 'color-alarm': contact.state !== 'noAlarm'
                        && contact.state !== 'waiting' }">
                        {{ subtitle(contact.textNumber) }}
                    </p>
                    <p *ngIf="contact.textNumber !== 0
                            && contact.textNumber !== null && contact.index !== 1"
                        class="dropdown-list__item-name"
                        [ngClass]="{ 'color-alarm': contact.state !== 'noAlarm'
                            && contact.state !== 'waiting' }">
                            {{ subtitle(contact.textNumber) + ' ' + (contact.index) }}
                    </p>
                    <div class="dropdown-list__value" *ngIf="contact.state === 'noAlarm'">
                        <div class="dropdown-list__value-wrapper">
                            <div class="dropdown-list__value dropdown-list__value--small"
                                *ngIf="contact.batteryLevel !== null">
                                 <p class="dropdown-list__value-name"
                                     data-testid="relay"
                                     [ngClass]="{ 'color-alarm': contact.state != 'noAlarm' }">
                                     {{ contact.relayState == 'on'
                                         ? subtitle(1447) : subtitle(924) }}
                                 </p>
                            </div>
                        </div>
                        <div class="dropdown-list__value-wrapper">
                            <div class="dropdown-list__value dropdown-list__value--small"
                                *ngIf="contact.signalStrength !== null">
                                 <img class="dropdown-list__signal"
                                     data-testid="signal-icon"
                                     ngSrc="{{ zones.signalIcon(contact)}} "
                                     width="19" height="19" alt="" />
                            </div>
                        </div>
                    </div>
                    <div class="dropdown-list__value dropdown-list__value--single"
                        *ngIf="contact.state == 'waiting'">
                        <p class="dropdown-list__value-name">
                            {{ subtitle(3162) }}
                        </p>
                    </div>

                    <div class="dropdown-list__value dropdown-list__value--single"
                        *ngIf="contact.state == 'noCommunication'"
                        [ngClass]="{ 'color-alarm': contact.state != 'noAlarm' }">
                        <p class="dropdown-list__value-name">
                            {{ subtitle(1808) }}
                        </p>
                    </div>
                    <div class="dropdown-list__value dropdown-list__value--single"
                        *ngIf="contact.state == 'lowBattery'"
                        [ngClass]="{ 'color-alarm': contact.state != 'noAlarm' }">
                        <p class="dropdown-list__value-name">
                           {{ subtitle(2884) + ' - ' + subtitle(2885) }}
                        </p>
                    </div>
                    <div class="dropdown-list__value dropdown-list__value--single"
                        *ngIf="contact.state == 'damaged'"
                        [ngClass]="{ 'color-alarm': contact.state != 'noAlarm' }">
                        <p class="dropdown-list__value-name">
                            {{ subtitle(2883) }}
                        </p>
                    </div>
                </div>

                <div class="dropdown-list dropdown-list--underfloor"
                    *ngIf="zones.selectedZone['underfloor'].id">
                    <p class="dropdown-list__header font-15 font-bold">
                        {{ subtitle(208) }}
                    </p>
                    <div class="dropdown-list__item color-basic font-14 font-bold">
                        <p class="dropdown-list__item-name">{{ subtitle(806) }}</p>
                        <div class="dropdown-list__value dropdown-list__value--single">
                            <p class="dropdown-list__value-name">
                               {{ zone.underfloor.mode | underfloorMode }}
                            </p>
                        </div>
                    </div>
                    <div class="dropdown-list__item color-basic font-14 font-bold">
                        <p class="dropdown-list__item-name">{{ subtitle(4273) }}</p>
                        <div class="dropdown-list__value dropdown-list__value--single">
                            <p class="dropdown-list__value-name">
                               {{ zone.underfloor.currentState | underfloorState }}
                            </p>
                        </div>
                    </div>
                    <div class="dropdown-list__item color-basic font-14 font-bold">
                        <p class="dropdown-list__item-name">{{ subtitle(4272) }}</p>
                        <div class="dropdown-list__value dropdown-list__value--single">
                            <p *ngIf="zone.underfloor.temperature !== null"
                               class="dropdown-list__value-name">
                               {{ zone.underfloor.temperature | format:7 }}
                            </p>
                            <p *ngIf="zone.underfloor.temperature === null"
                               class="dropdown-list__value-name">--.-</p>
                        </div>
                    </div>
                    <div class="dropdown-list__item color-basic font-14 font-bold"
                         *ngIf="zone.underfloor.signalStrength !== null
                            || zone.underfloor.batteryLevel !== null">
                        <p class="dropdown-list__item-name"
                            [ngClass]="{ 'color-alarm': zone.underfloor.batteryLevel <=10
                                && zone.underfloor.batteryLevel !== null }">
                            {{ subtitle(3589) }}
                        </p>
                        <div class="dropdown-list__value">
                            <div class="dropdown-list__value-wrapper">
                                <div class="dropdown-list__value dropdown-list__value--small"
                                    *ngIf="zone.underfloor.batteryLevel !== null">
                                               <img class="dropdown-list__battery"
                                                   data-testid="battery-level"
                                                   ngSrc="/assets/img/zone_icons/battery.svg"
                                                   width="16" height="16" alt="" />
                                    <p class="dropdown-list__value-name"
                                        [ngClass]="{ 'color-alarm': zone.underfloor.batteryLevel <=10 }">
                                        {{ zone.underfloor.batteryLevel | format:8 }}
                                    </p>
                                </div>
                            </div>
                            <div class="dropdown-list__value-wrapper">
                                <div class="dropdown-list__value dropdown-list__value--small"
                                    *ngIf="zone.underfloor.signalStrength !== null">
                                               <img class="dropdown-list__signal"
                                                   data-testid="signal-icon"
                                                   ngSrc="{{ zones.signalIcon({signalStrength: zone.underfloor.signalStrength})}}"
                                                   width="19" height="19" alt="" />
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="dropdown-list__item color-basic font-14 font-bold">
                        <p class="dropdown-list__item-name">
                            {{ subtitle(3396) }}
                        </p>
                        <div class="dropdown-list__value dropdown-list__value--single">
                            <p class="dropdown-list__value-name">
                                {{ zone.underfloor.sensorType | underfloorSensorType }}
                            </p>
                        </div>
                    </div>
                    <div class="dropdown-list__item color-basic font-14 font-bold"
                         *ngIf="zone.underfloor.floorPump !== 'noPump'">
                        <p class="dropdown-list__item-name">
                            {{ subtitle(582) }}
                        </p>
                        <div class="dropdown-list__value dropdown-list__value--single">
                            <p class="dropdown-list__value-name">
                                {{ zone.underfloor.floorPump === 'off'
                                    ? subtitle(922) : subtitle(3498) }}
                            </p>
                        </div>
                    </div>
                    <div class="dropdown-list__item color-basic font-14 font-bold"
                        *ngIf="zone.underfloor.events.correctWork">
                        <p class="dropdown-list__item-name">
                            {{ subtitle(3956) }}
                        </p>
                        <div class="dropdown-list__value dropdown-list__value--single">
                            <p class="dropdown-list__value-name">
                                {{ subtitle(594) }}
                            </p>
                        </div>
                    </div>
                    <div class="dropdown-list__item color-basic font-14 font-bold"
                        *ngIf="zone.underfloor.events.serviceError">
                        <p class="dropdown-list__item-name">
                            {{ subtitle(3956) }}
                        </p>
                        <div class="dropdown-list__value dropdown-list__value--single">
                            <p class="dropdown-list__value-name">
                                {{ subtitle(4277) }}
                            </p>
                        </div>
                    </div>
                    <div class="dropdown-list__item color-basic font-14 font-bold"
                        *ngIf="zone.underfloor.events.noCommunication">
                        <p class="dropdown-list__item-name color-alarm">
                            {{ subtitle(4282) }}
                        </p>
                        <div class="dropdown-list__value dropdown-list__value--single">
                            <p class="dropdown-list__value-name color-alarm">
                                {{ subtitle(1808) }}
                            </p>
                        </div>
                    </div>
                    <div class="dropdown-list__item color-basic font-14 font-bold"
                        *ngIf="zone.underfloor.events.sensorDamaged">
                        <p class="dropdown-list__item-name color-alarm">
                            {{ subtitle(4282) }}
                        </p>
                        <div class="dropdown-list__value dropdown-list__value--single">
                            <p class="dropdown-list__value-name color-alarm">
                                {{ subtitle(1807) }}
                            </p>
                        </div>
                    </div>
                    <div class="dropdown-list__item color-basic font-14 font-bold"
                        *ngIf="zone.underfloor.events.lowBattery">
                        <p class="dropdown-list__item-name color-alarm">
                            {{ subtitle(4282) }}
                        </p>
                        <div class="dropdown-list__value dropdown-list__value--single">
                            <p class="dropdown-list__value-name color-alarm">
                                {{ subtitle(2727) }}
                            </p>
                        </div>
                    </div>
                    <div class="dropdown-list__item color-basic font-14 font-bold"
                        *ngIf="zone.underfloor.events.lowSignal">
                        <p class="dropdown-list__item-name color-alarm">
                            {{ subtitle(4282) }}
                        </p>
                        <div class="dropdown-list__value dropdown-list__value--single">
                            <p class="dropdown-list__value-name color-alarm">
                                {{ subtitle(698) }}
                            </p>
                        </div>
                    </div>
                    <div class="dropdown-list__item color-basic font-14 font-bold"
                        *ngIf="zone.underfloor.events.tempTooHigh">
                        <p class="dropdown-list__item-name color-alarm">
                            {{ subtitle(4282) }}
                        </p>
                        <div class="dropdown-list__value dropdown-list__value--single">
                            <p class="dropdown-list__value-name color-alarm">
                                {{ subtitle(4280) }}
                            </p>
                        </div>
                    </div>
                    <div class="dropdown-list__item color-basic font-14 font-bold"
                        *ngIf="zone.underfloor.events.tempTooLow">
                        <p class="dropdown-list__item-name color-alarm">
                            {{ subtitle(4282) }}
                        </p>
                        <div class="dropdown-list__value dropdown-list__value--single">
                            <p class="dropdown-list__value-name color-alarm">
                                {{ subtitle(4278) }}
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
